module.exports = __webpack_public_path__ + "static/media/sonic.2bb39284.gif";